import { GenericGeoEvent } from 'features/geoEvents/geoEvent.types';
import { NotificationType } from 'features/notifications/notifications.types';
import { useWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

type UseNotificationTypeFormFieldChangesProps = {
  geoEvent: GenericGeoEvent;
};

type FormValues = {
  notificationType: NotificationType;
};

type ChangeKey = keyof FormValues;

type ChangeMap = Partial<Record<ChangeKey, string>>;

export const useNotificationTypeFormFieldChanges = (
  props: UseNotificationTypeFormFieldChangesProps,
): ChangeMap => {
  const { geoEvent } = props;
  const { t } = useTranslation();

  const formNotificationType = useWatch<FormValues>({
    name: 'notificationType',
  });

  const notificationTypeChanged =
    geoEvent.notificationType !== formNotificationType;

  const changes: ChangeMap = {};
  if (notificationTypeChanged) {
    changes.notificationType = t('geoEventChangelog.notificationType', {
      prevValue: t(`common.${geoEvent.notificationType}`),
      newValue: t(`common.${formNotificationType}`),
    });
  }

  return changes;
};
